import Loadable from '../../components/loadable';

const ArchivedSequencesList = Loadable({
  loader: () => import('../../pages/sequences/archived_sequences_list/archived_sequence_list'),
  type: 'block',
});

angular.module('gym').value('ArchivedSequencesList', ArchivedSequencesList);

const UnarchiveSequenceModal = Loadable({
  loader: () => import('../../pages/sequences/archived_sequences_list/unarchive_sequence_modal'),
  type: 'modal',
});

angular.module('gym').value('UnarchiveSequenceModal', UnarchiveSequenceModal);

const SequenceDetailsModal = Loadable({
  loader: () => import('../../pages/sequences/archived_sequences_list/sequence_details_modal'),
  type: 'modal',
});

angular.module('gym').value('SequenceDetailsModal', SequenceDetailsModal);
